import { GrafanaFaroService } from "../services/grafana-faro.service";

export function provideTrackerErrorInitializer(grafanaFaroService: GrafanaFaroService) {
  return () => {
    return grafanaFaroService.initialize();
  };
}

